/**
 * ローカルデータの変更通知。
 * 書き込みのたびにバージョンを進め、購読しているビューが再取得する。
 */
import { useSyncExternalStore } from 'react';

let version = 0;
const listeners = new Set<() => void>();

export function bumpData(): void {
  version += 1;
  listeners.forEach((l) => l());
}

export function useDataVersion(): number {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => version,
  );
}

/**
 * outbox に操作が積まれたことの通知。
 * outbox から同期エンジンを直接呼ぶと import が循環するため、ここを経由させる。
 */
const outboxListeners = new Set<() => void>();

export function notifyOutboxChanged(): void {
  outboxListeners.forEach((l) => l());
}

export function onOutboxChanged(fn: () => void): () => void {
  outboxListeners.add(fn);
  return () => outboxListeners.delete(fn);
}
